import {createContext, useState} from 'react'

export const NavigationContext = createContext({
  title: '',
  setTitle: () => {}
})

export const NavigationContextProvider = ({children}) => {
  const [title, setTitle] = useState('')
  return <NavigationContext.Provider value={{title, setTitle}}>{children}</NavigationContext.Provider>
}
